import {
  Component,
  ViewChild,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-upload-input',
  templateUrl: './upload-input.component.html',
  styleUrls: ['./upload-input.component.scss'],
})
export class UploadInputComponent {
  @ViewChild('searchTextField', { static: false }) searchTextField: any;
  @Input() fileName: string;
  @Output() emitClick: EventEmitter<any> = new EventEmitter();
  @Output() cancelFile: EventEmitter<any> = new EventEmitter();

  get isInputFilled() {
    return (this.fileName && this.fileName.length >= 1) ? true : false;
  }

  get inputLabel() {
    return this.fileName && this.fileName.length >= 1 ? this.fileName : 'Select attachment';
  }

  clickInput() {
    this.emitClick.emit();
  }

  resetFile() {
    this.cancelFile.emit();
  }
}
